/**
 * 1.7.9 — the calls more than one screen shares. A call only one screen makes lives beside that screen.
 */
import type { AnnouncementDetail } from '@shared/announcements';
import type { AnnounceEventInput, EventAnnounceState } from '@shared/event-announce';
import { press } from './api';

export interface AnnounceEventResult {
  /** The draft (open it with `/events/announcements?draft=<announcement.id>`, or edit it in place and send it with the announcements' own calls). */
  announcement: AnnouncementDetail;
  announce: EventAnnounceState;
  message: string;
}
/** Announce this event: makes an announcement's draft about it, to all tenants with an email. Nothing is sent by it. */
export const announceEventReq = (eventId: string, input: AnnounceEventInput = {}) => press<AnnounceEventResult>(eventId, { what: 'announce', announce: input });
